export default {
    loading: false,
    items: [],

    admin: false,
    finances: false,
    financesPayments: false,
    financesStatements: false,
    financesRegulars: false,
    financesInvoices: false,
    financesCertificates: false,
    financesOsv: true, ///TODO: Нет настройки

    //
    // financesPaymentsAdd: false,
    // financesPaymentsEdit: false,
    //
    // financesRegularsAdd: false,
    // financesRegularsEdit: false,
    //
    // financesInvoicesAdd: false,
    // financesInvoicesEdit: false,
    //
    // financesCertificatesAdd: false,
    // financesCertificatesEdit: false,
    //
    // financesStatementsAdd: false,
    // financesStatementsEdit: false,
    //
}